// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type WebinarsLearningCenterQueryVariables = Types.Exact<{
  path: Types.Scalars['String']['input'];
}>;


export type WebinarsLearningCenterQuery = { __typename?: 'Query', getWebinarsLearningCenter?: Array<{ __typename?: 'Webinars', pagePath?: string | null, title?: string | null, description?: string | null, summary?: string | null, url?: string | null, duration?: string | null, primaryCategory?: string | null, primarySubCategory?: string | null, upcoming?: boolean | null, language?: Array<string | null> | null, category?: Array<string | null> | null, speakers?: Array<{ __typename?: 'Speakers', speakerBio?: string | null, name?: string | null, title?: string | null, company?: string | null, image?: { __typename?: 'SpeakerImage', src?: string | null, alt?: string | null, widths?: Array<string | null> | null, linkUrl?: string | null, title?: string | null, externalUrl?: boolean | null } | null } | null> | null, sessions?: Array<{ __typename?: 'Sessions', sessionUrl?: string | null, timestamp?: string | null, timezone?: string | null } | null> | null } | null> | null };


export const WebinarsLearningCenterDocument = gql`
    query WebinarsLearningCenter($path: String!) {
  getWebinarsLearningCenter(path: $path) {
    pagePath
    title
    description
    summary
    url
    duration
    speakers {
      speakerBio
      name
      title
      company
      image {
        src
        alt
        widths
        linkUrl
        title
        externalUrl
      }
    }
    sessions {
      sessionUrl
      timestamp
      timezone
    }
    primaryCategory
    primarySubCategory
    upcoming
    language
    category
  }
}
    `;
export type WebinarsLearningCenterComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<WebinarsLearningCenterQuery, WebinarsLearningCenterQueryVariables>, 'query'> & ({ variables: WebinarsLearningCenterQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WebinarsLearningCenterComponent = (props: WebinarsLearningCenterComponentProps) => (
      <ApolloReactComponents.Query<WebinarsLearningCenterQuery, WebinarsLearningCenterQueryVariables> query={WebinarsLearningCenterDocument} {...props} />
    );
    

/**
 * __useWebinarsLearningCenterQuery__
 *
 * To run a query within a React component, call `useWebinarsLearningCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebinarsLearningCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebinarsLearningCenterQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useWebinarsLearningCenterQuery(baseOptions: Apollo.QueryHookOptions<WebinarsLearningCenterQuery, WebinarsLearningCenterQueryVariables> & ({ variables: WebinarsLearningCenterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebinarsLearningCenterQuery, WebinarsLearningCenterQueryVariables>(WebinarsLearningCenterDocument, options);
      }
export function useWebinarsLearningCenterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebinarsLearningCenterQuery, WebinarsLearningCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebinarsLearningCenterQuery, WebinarsLearningCenterQueryVariables>(WebinarsLearningCenterDocument, options);
        }
export function useWebinarsLearningCenterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebinarsLearningCenterQuery, WebinarsLearningCenterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebinarsLearningCenterQuery, WebinarsLearningCenterQueryVariables>(WebinarsLearningCenterDocument, options);
        }
export type WebinarsLearningCenterQueryHookResult = ReturnType<typeof useWebinarsLearningCenterQuery>;
export type WebinarsLearningCenterLazyQueryHookResult = ReturnType<typeof useWebinarsLearningCenterLazyQuery>;
export type WebinarsLearningCenterSuspenseQueryHookResult = ReturnType<typeof useWebinarsLearningCenterSuspenseQuery>;
export type WebinarsLearningCenterQueryResult = Apollo.QueryResult<WebinarsLearningCenterQuery, WebinarsLearningCenterQueryVariables>;